import { versionConfig, statusConfig, regionConfig, languageConfig } from '../options.js';
import { CCollateral } from '../../models/collateral.js';
const collateralModel = new CCollateral();
export const collateral = {
    model: collateralModel,
    type: 'collateral',
    contentType: 'collateral',
    editor: 'html',
    editorTitle: { name: 'title', placeholder: 'title' },
    supportContent: ['collateral'],
    documentProperty: 'content',
    title: 'Collateral',
    plural: 'Collateral',
    endpoint: 'collateral',
    version: versionConfig,
    listing: {
        type: 'grid',
        gridSupportContent: [],
        gridContentType: 'collateral',
        gridCombineProperty: 'slug',
        gridDecode: ['title'],
        gridJoin: { properties: ['tags', 'region', 'language'] },
        gridFormat: [
            // todo: move gridDecode into normalized gridFormat { format: 'decode', properties: ['title'] },
            { format: 'date', properties: ['created', 'modified'] },
        ],
        gridColumns: ['title', 'tags', 'type', 'created', 'modified'],
        gridSearch: [{ key: 'title', combine: true }],
        gridHasChildren: true,
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            { label: 'Type', key: 'type', uppercase: true, default: true },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
    },
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'type',
        'client',
        'region',
        'language',
        'created',
        'modified',
        'tags',
        'categories',
    ],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
            { label: 'Author', name: 'author', input: 'select' },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        category: [{ label: 'Categories', name: 'categories', type: 'advisor' }],
        tag: [
            {
                label: 'Tags',
                name: 'tags',
                input: 'multiselect',
                type: 'standard',
                description: 'Type to search. Click dropdown entry to add tag. Click tag to remove.',
            },
            {
                label: 'Internal Tags',
                name: 'internalTags',
                input: 'multiselect',
                type: 'internal',
                description: 'Type to search. Click dropdown entry to add tag. Click tag to remove.',
            },
        ],
        images: [{ label: 'Featured Image', name: 'image' }],
    },
    meta: [
        {
            label: 'Excerpt',
            name: 'excerpt',
            input: 'textarea',
            description: 'Content Excerpt (displays in library index).',
        },
        {
            label: 'Content Type',
            name: 'type',
            input: 'select',
            description: 'Please select the content type.',
            options: [
                { label: 'Article', value: 'article' },
                { label: 'Document', value: 'Document' },
                { label: 'Download', value: 'Download' },
                { label: 'Image', value: 'Image' },
                { label: 'PDF', value: 'PDF' },
                { label: 'PowerPoint', value: 'PowerPoint' },
            ],
        },
        {
            label: 'Notes',
            name: 'notes',
            input: 'textarea',
            description: 'Document notes.',
        },
        {
            label: 'Reference Link',
            name: 'referenceLink',
            input: 'text',
            description: 'Please enter the Reference Link for content types other than Articles and Blogs.',
        },
        {
            label: 'Mime Type',
            name: 'mimeType',
            input: 'select',
            description: 'Please select the content mime type.',
            options: [
                { label: 'HTML', value: 'text/html' },
                { label: 'PDF', value: 'application/pdf' },
                { label: '.DOC', value: 'application/msword' },
                { label: '.XLS .XLT .XLA', value: 'application/vnd.ms-excel' },
                {
                    label: '.PPT .POT .PPS .PPA',
                    value: 'application/vnd.ms-powerpoint',
                },
            ],
        },
        {
            label: 'Priority',
            name: 'priority',
            input: 'number',
            description: 'Please enter the content priority number with 100 being the highest and 0 being the lowest.',
        },
        {
            label: 'Exclude Client',
            name: 'exclude',
            input: 'multiselect',
            description: 'Add clients to prevent them from viewing this article.',
        },
        {
            label: 'Show in Library',
            name: 'showInLibrary',
            input: 'select',
            description: 'Controls if this content should displayed in the library index (still allows for direct linking).',
            options: [
                { label: 'True', value: true },
                { label: 'False', value: false },
            ],
        },
        {
            label: 'Redirect',
            name: 'redirect',
            input: 'text',
            description: 'If this field is set content will redirect to requested internal article link (leave empty otherwise).',
        },
        {
            label: 'Source',
            name: 'source',
            input: 'select',
            description: 'Provider of this article.',
            options: [{ label: 'Financial Finesse', value: 'Financial Finesse' }],
        },
    ],
    validate: [
        { property: 'title' },
        { property: 'slug' },
        { property: 'region' },
        { property: 'language' },
    ],
};
//# sourceMappingURL=collateral.js.map